import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-teaser-meta/jb-ref-teaser-meta.ts
import "@bjb/bjb-web-components/dist/components/icons/jb-calendar-icon/jb-calendar-icon";
import "@bjb/bjb-web-components/dist/components/jb-date/jb-date";
import "@bjb/bjb-web-components/dist/components/jb-time/jb-time";
import { initializeLink, jbLinkClickedEventToJbTrackingEvent, Linkable } from "@bjb/bjb-web-components/dist/mixins";
import { spreadProps } from "@open-wc/lit-helpers";
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property, queryAll } from "lit/decorators.js";
import { when } from "lit/directives/when.js";

// src/components/jb-ref-teaser-meta/jb-ref-teaser-meta.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_teaser_meta_default = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* stylelint-disable */
/* stylelint-enable */
.tags, .tags .tag a, .infos {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-weight: 700;
}

.infos {
  font-size: 11px;
  letter-spacing: 1px;
  line-height: 16px;
  text-transform: uppercase;
}

.tags .tag a {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 11px;
  letter-spacing: 1px;
  line-height: 16px;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
:host {
  color: var(--host-color, #141e55);
}

.infos {
  display: flex;
  flex-wrap: wrap;
  letter-spacing: 1px;
  gap: var(--spacing-s);
}
.infos div {
  display: inline-flex;
}
.infos jb-calendar-icon {
  margin-right: 10px;
}

.infos + .tags {
  margin-top: var(--spacing-s, 20px);
}

.tags {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  gap: var(--spacing-3xs);
}
@media (min-width: 600px) {
  .tags {
    gap: var(--spacing-xs);
  }
}
.tags .tag {
  display: flex;
}
.tags .tag a {
  border: 1px solid rgba(20, 30, 85, 0.2);
  color: #141e55 !important;
  padding: 4px 9px;
  text-decoration: none;
  text-transform: uppercase;
  transition: border 0.7s ease-in-out 0s;
}
.tags .tag a:hover {
  border: 1px solid #141e55;
  transition: border 0.7s ease-in-out 0s;
}`;

// src/components/jb-ref-teaser-meta/jb-ref-teaser-meta.ts
var JbRefTeaserMeta = class extends Linkable(LitElement) {
  constructor() {
    super(...arguments);
    this.tags = [];
  }
  updated() {
    this._tagLinks?.forEach((link) => {
      initializeLink(link);
    });
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "teaser-meta"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _renderInfos() {
    return this.infos?.map((info) => {
      switch (info.type) {
        case "date":
          return html`<div><jb-calendar-icon></jb-calendar-icon><jb-date date=${info.value}></jb-date></div>`;
        case "readingTime":
          return html`<div>
            <jb-time time=${info.value}></jb-time>
          </div>`;
        case "text":
          return html`<span>${info.value}</span>`;
        default:
          return nothing;
      }
    });
  }
  _renderTags() {
    return this.tags?.map(
      (tag) => html`<div class="tag">
          <a
            ${spreadProps({ ...tag.link })}
            @jb-link:clicked=${this._tracking}
            >${tag.text}</a
          >
        </div>`
    );
  }
  render() {
    return html`<div class="teaser-meta">
      ${when(this.infos?.length, () => html`<div class="infos">${this._renderInfos()}</div>`)}
      ${when(this.tags?.length, () => html`<div class="tags">${this._renderTags()}</div>`)}
    </div>`;
  }
};
JbRefTeaserMeta.styles = unsafeCSS(jb_ref_teaser_meta_default);
__decorateClass([
  property({ type: Array })
], JbRefTeaserMeta.prototype, "infos", 2);
__decorateClass([
  property({ type: Array })
], JbRefTeaserMeta.prototype, "tags", 2);
__decorateClass([
  queryAll("a")
], JbRefTeaserMeta.prototype, "_tagLinks", 2);
JbRefTeaserMeta = __decorateClass([
  customElement("jb-ref-teaser-meta")
], JbRefTeaserMeta);

export {
  JbRefTeaserMeta
};
